<section 
   data-component="popup-site-limited-access"
   role="dialog"
   [attr.aria-describedby]= "ariaDescribedBy">
   
   <div>
	<h1 id="{{ariaTitleId}}" 
		role="heading"
		[innerHTML]="limitedAccessContent?.copy$$header_setting_up_your_account?.TEXT"></h1>
	<p id="{{ariaBodyId}}"
		role="heading"
		[innerHTML]="limitedAccessContent?.copy$$info_some_information_unavailable?.TEXT"></p>
	</div>
	<!--close button on top right corner-->
	<section class="close-modal">
		<button
			class="close-modal-icon text-button focus-here"
			[attr.aria-label]="limitedAccessContent?.copy$$close_dialog?.WCAG_TEXT" 
			(click)="close()">
		</button>
	</section>
</section>